import React from "react";
import Search from "./Search";
import useGroupSearch from "../../hooks/useGroupSearch";

/**
 * GroupSearch - Simplified group selection component
 *
 * @param {Array} allGroups - Array of all available groups
 * @param {Function} onSelectedGroupIdsChange - Callback that receives array:
 *   - ["All"] - when all groups selected
 *   - ["Official Groups"] - when official supporters groups selected
 *   - [groupId1, groupId2, ...] - when specific groups selected
 * @param {string} label - Label for the search component
 * @param {string} placeholder - Placeholder text
 */
const GroupSearch = ({
  allGroups = [],
  onSelectedGroupIdsChange,
  label,
  placeholder = "Default group selection is 'worldwide'. Select groups by region (Europe) and/or name (Atlanta) to target",
}) => {
  // All logic is now handled in the hook
  const { searchOptions, selectedOptions, count, onSelectedOptionsChange } =
    useGroupSearch(allGroups, onSelectedGroupIdsChange);

  return (
    <Search
      options={searchOptions}
      onSelectedOptionsChange={onSelectedOptionsChange}
      selectedOptions={selectedOptions}
      label={label}
      placeholder={placeholder}
      count={count}
    />
  );
};

export default GroupSearch;
